import { combineReducers } from 'redux'

import vendorReducer from './reducers/vendorReducer'
import userReducer from './reducers/userReducer'
import generalReducer from './reducers/generalReducer'
import discountReducer from './reducers/discountReducer'
import offerReducer from './reducers/offerReducer'
import promotionReducer from './reducers/promotionReducer'
import loyaltyLevelReducer from './reducers/loyaltyLevel'
import reportReducer from './reducers/reportReducer'
import feedbackReducer from './reducers/feedbackReducer'
import conditionalReducer from './reducers/conditionalReducer'

const rootReducer = combineReducers({
  vendorReducer,
  userReducer,
  generalReducer,
  discountReducer,
  offerReducer,
  promotionReducer,
  loyaltyLevelReducer,
  reportReducer,
  feedbackReducer,
  conditionalReducer,
})

export default rootReducer
